import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getAllCoursesForPersons = (detailed) => dispatch => {
  dispatch({ type: "GET_ALL_COURSES_LOADING" });
  api
    .coursesGetAllForPersons(detailed)
    .then(resp => {
      dispatch(operationSucceeded(resp.data));
      dispatch({ type: "GET_ALL_COURSES_LOADING_DONE" });
    })
    .catch(e => {
      jsError(e);
      dispatch({ type: "GET_ALL_COURSES_LOADING_DONE" });
      dispatch(operationFail());
      dispatch(buildAlertWithLocalizedMessages(
        "ERROR",
        "GetAllCoursesErrorAlertTitle",
        "Virhe muiden koulutusten haussa",
        e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
    });
};

const operationSucceeded = data => ({
  type: "GET_ALL_COURSES_SUCCEEDED",
  payload: { courses: data },
});

const operationFail = () => ({
  type: "GET_ALL_COURSES_FAIL",
});
